// Fetch an image URL and return a base64 data URL (needed by jsPDF.addImage).
// Also returns the natural pixel size so we can preserve aspect ratio.
export async function imageToDataUrl(url) {
  if (!url) return null;
  try {
    const res = await fetch(url, { mode: "cors" });
    const blob = await res.blob();
    const dataUrl = await new Promise((resolve, reject) => {
      const fr = new FileReader();
      fr.onload = () => resolve(fr.result);
      fr.onerror = reject;
      fr.readAsDataURL(blob);
    });
    const size = await new Promise((resolve) => {
      const img = new Image();
      img.onload = () => resolve({ width: img.naturalWidth, height: img.naturalHeight });
      img.onerror = () => resolve({ width: 0, height: 0 });
      img.src = dataUrl;
    });
    return { dataUrl, width: size.width, height: size.height };
  } catch (e) {
    return null;
  }
}
